import { render, staticRenderFns } from "./CallsPerCampaignPenitrationByUser.vue?vue&type=template&id=37bf1996&scoped=true&"
import script from "./CallsPerCampaignPenitrationByUser.vue?vue&type=script&lang=js&"
export * from "./CallsPerCampaignPenitrationByUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bf1996",
  null
  
)

export default component.exports